import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useRef } from 'react';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import Torpedo from '../BaseTorpedo';
import { useMeasuredCookie } from '../../Measured/useMeasuredCookie';
function getMeasuredContainer(containerFromProps, measuredContainer) {
    var _measuredContainer_width;
    return {
        width: Number((_measuredContainer_width = measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width) !== null && _measuredContainer_width !== void 0 ? _measuredContainer_width : containerFromProps.width)
    };
}
const MeasuredTorpedo = (props)=>{
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);
    const measuredContainer = useMeasuredCookie(props.cookieType, containerRef, {
        cookieDim: 'width',
        defaultSize: props.defaultSize,
        listenOnWindow: true,
        sentinelRef
    });
    useDebugRerenders('MeasuredTorpedo', _object_spread_props(_object_spread({}, props), {
        measuredContainer
    }));
    const container = getMeasuredContainer(props.container, measuredContainer);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: sentinelRef,
        style: {
            maxWidth: '100%'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ React.createElement(Torpedo, _extends({}, props, {
        container: container
    }))));
};
MeasuredTorpedo.displayName = 'MeasuredTorpedo';
export default MeasuredTorpedo;
